import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import Whychooseimg01 from '../../../assets/images/shape/why-choose-shape-3.png';
import Whychooseimg02 from '../../../assets/images/shape/why-choose-shape-4.png';
import Whychooseimg03 from '../../../assets/images/support.png';

const Whychoosetwo = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(
                '.why-choose-two-image'
            );

            elements.forEach((el) => {
                const elementTop = el.getBoundingClientRect().top;
                const elementBottom = el.getBoundingClientRect().bottom;
                const viewportTop = 0;
                const viewportBottom = window.innerHeight;

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    el.classList.add('active');
                }
            });
        };


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });
   
    return (
        <div className="why-choose-two">
            
            <div className="container">
                <div className="row gutter-y-30">
                    <div className="col-lg-7 align-self-center">
                        <div className="why-choose-right-two">
                            <div className="heading-box heading-white">
                                
                                <h2 className="heading-title wow fadeInUp animated animated text-black" id='global'>
                                Global NRI support, delivered with precision
                                </h2>
                            </div>
                            <p id='paragraph'>
                            We specialize in delivering swift, end-to-end solutions for NRIs, managing everything from complex matter - requiring minimum travel. With a team committed to integrity, urgency, and care, you can focus on your life abroad while we handle the rest back home.
                            </p>
                           
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="why-choose-two-image">
                            <img
                                src={Whychooseimg03} alt="why-choose-image"
                            />
                            <div className="image-shape">
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 mt-5">
                        <div className="row gutter-y-30">
                            {whychoosedata.map((data, index) =>
                                <div key={index}
                                    className="col-lg-4" >
                                    <div className="why-choose-two-box">
                                        <i className="flaticon-transparency" />
                                        <div className="why-choose-two-box-info">
                                            <h4>{data.heading}</h4>
                                            <p>
                                                {data.about}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>
            </div>
        </div >


    )
}
export default Whychoosetwo;